<template>
    <div class="row">
        <div class="col-lg-4 password-input-position">
            <div class="input-group">
                <input autocomplete="off" :type="inputType" ref="password" @blur="focusOutPassword()"
                    @keyup="keyupPassword()" :class="inputclass" :placeholder="inputplaceholder" :name="inputname"
                    :value='value' @input="updateValue()" />
                <div class="input-group-append toggle-hide" @click="onShowHideToggle">
                    <span class="input-group-text" id="basic-addon3">{{buttonText}}</span>
                </div>
            </div>

        </div>
        <div class="col-lg-3 password_desc">
            <ul style="margin-left:20px">
                <template v-for="item in listItems">
                    <label class="fas fa-check-circle" :style="{color:item.FontAwesomeColor}">&nbsp;<span
                            :class="item.ItemClass">{{item.Text}} </span> </label>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["value", "inputclass", "inputplaceholder", "inputname", "position"],
        created() {

        },
        data() {
            return {
                parentMessage: "",
                showPopoverPV: true,
                position: "right",
                isShowPassword: false,
                inputType: "password",
                buttonText: "SHOW",

                listItems: [
                    { Id: 1, Text: 'At least 8 characters', ItemClass: 'text-secondary', FontAwesomeColor: 'grey' },
                    { Id: 2, Text: 'At least 1 upper case letter', ItemClass: 'text-secondary', FontAwesomeColor: 'grey' },
                    { Id: 3, Text: 'At least 1 lower case letter', ItemClass: 'text-secondary', FontAwesomeColor: 'grey' },
                    { Id: 4, Text: 'At least 1 digit', ItemClass: 'text-secondary', FontAwesomeColor: 'grey' },

                ]
            };
        },
        methods: {
            onShowHideToggle() {
                this.isShowPassword = !this.isShowPassword;
                if (this.isShowPassword) {
                    this.inputType = "text",
                        this.buttonText = "HIDE"
                } else {
                    this.inputType = "password",
                        this.buttonText = "SHOW"
                }
            },
            updateValue() {
                this.$emit("input", this.$refs.password.value);
            },
            focusPassword() {
                this.checkPasswordCriteria();
            },
            focusOutPassword() {
                this.checkPasswordCriteria();
            },
            keyupPassword() {
                this.checkPasswordCriteria();
            },
            checkPasswordCriteria() {
                var password = this.value;
                var upperCase = new RegExp('[A-Z]');
                var lowerCase = new RegExp('[a-z]');
                var numbers = new RegExp('[0-9]');

                if (password && password.length >= 8) {
                    this.listItems[0].ItemClass = 'text-success';
                    this.listItems[0].FontAwesomeColor = 'green';
                }
                else {
                    this.listItems[0].ItemClass = 'text-secondary';
                    this.listItems[0].FontAwesomeColor = 'grey';
                }
                if (password && password.match(upperCase)) {
                    this.listItems[1].ItemClass = 'text-success';
                    this.listItems[1].FontAwesomeColor = 'green';
                } else {
                    this.listItems[1].ItemClass = 'text-secondary';
                    this.listItems[1].FontAwesomeColor = 'grey';
                }

                if (password && password.match(lowerCase)) {
                    this.listItems[2].ItemClass = 'text-success';
                    this.listItems[2].FontAwesomeColor = 'green';
                } else {
                    this.listItems[2].ItemClass = 'text-secondary';
                    this.listItems[2].FontAwesomeColor = 'grey';
                }

                if (password && password.match(numbers)) {
                    this.listItems[3].ItemClass = 'text-success';
                    this.listItems[3].FontAwesomeColor = 'green';
                }
                else {
                    this.listItems[3].ItemClass = 'text-secondary';
                    this.listItems[3].FontAwesomeColor = 'grey';
                }

            }
        }
    };
</script>
<style scoped>
    .password-input-position {
        padding-top: 32px !important;
        padding-left: 30px !important;
    }
  
</style>
